export const TABS = {
	agentSignup: { value: 'agentSignup', text: "I'm an agent" },
	photographerSignup: { value: 'photographerSignup', text: "I'm a photographer" }
};
